module.exports = __webpack_public_path__ + "static/img/course_big.64216ded.png";